/**
 * Coeur desktop Shop / About mega panel — hover, focus, Escape; inert + aria when closed.
 */
(function () {
  const root = document.querySelector('[data-coeur-mega]');
  if (!root) return;

  const panel = root.querySelector('[data-coeur-mega-panel]');
  const tabs = root.querySelectorAll('[data-coeur-mega-tab]');
  const surface = root.querySelector('.coeur-header__mega-surface');
  if (!panel || !tabs.length || !surface) return;

  let active = 'shop';
  let open = false;
  let leaveTimer = null;
  const OPEN_CLASS = 'coeur-header__mega--open';

  if ('inert' in HTMLElement.prototype) {
    panel.inert = true;
  }

  function applyMode(mode) {
    active = mode;
    root.classList.toggle('coeur-header__mega--shop', mode === 'shop');
    root.classList.toggle('coeur-header__mega--about', mode === 'about');

    tabs.forEach((tab) => {
      const on = tab.getAttribute('data-coeur-mega-tab') === mode;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });

    const id = mode === 'shop' ? 'coeur-mega-tab-shop' : 'coeur-mega-tab-about';
    panel.setAttribute('aria-labelledby', id);
  }

  function openPanel(mode) {
    if (leaveTimer) {
      clearTimeout(leaveTimer);
      leaveTimer = null;
    }
    applyMode(mode || active);
    root.classList.add(OPEN_CLASS);
    panel.setAttribute('aria-hidden', 'false');
    if ('inert' in HTMLElement.prototype) {
      panel.inert = false;
    }
    open = true;
  }

  function closePanel() {
    open = false;
    root.classList.remove(OPEN_CLASS);
    panel.setAttribute('aria-hidden', 'true');
    if ('inert' in HTMLElement.prototype) {
      panel.inert = true;
    }
    tabs.forEach((tab) => tab.setAttribute('aria-selected', 'false'));
  }

  function scheduleClose() {
    if (leaveTimer) clearTimeout(leaveTimer);
    leaveTimer = setTimeout(() => {
      closePanel();
      leaveTimer = null;
    }, 160);
  }

  surface.addEventListener('mouseenter', () => {
    openPanel(active);
  });

  surface.addEventListener('mouseleave', () => {
    scheduleClose();
  });

  tabs.forEach((tab) => {
    const mode = tab.getAttribute('data-coeur-mega-tab');
    tab.addEventListener('mouseenter', () => {
      openPanel(mode);
    });
    tab.addEventListener('focus', () => {
      openPanel(mode);
    });
    tab.addEventListener('click', () => {
      openPanel(mode);
    });
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && open) {
      closePanel();
    }
  });
})();
